import { Table, type TableProps } from "@mantine/core"

export function AppTable({ children, minWidth = 800, ...props }: TableProps & { minWidth?: number }) {
  return (
    <Table.ScrollContainer minWidth={minWidth}>
      <Table fz="md" {...props}>
        {children}
      </Table>
    </Table.ScrollContainer>
  )
}
